export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "sellers_payments",
      layout: "dashboard",
    },
    path: "/seller-payments",
    name: "seller-payments",
    component: () => import("@/layouts/index/SellerPaymentIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de paiements vendeurs",
          layout: "dashboard",
        },
        path: "index",
        name: "seller-payments-index",
        component: () => import("@/views/seller-payments/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un paiement vendeur",
          layout: "dashboard",
        },
        path: "create",
        name: "seller-payments-create",
        component: () => import("@/views/seller-payments/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le paiement vendeur",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "seller-payments-edit",
        component: () => import("@/views/seller-payments/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du paiement vendeur",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "seller-payments-details",
        component: () => import("@/views/seller-payments/Details.vue"),
      },
    ],
  },
];
